import React from "react";


const Modal = ({ onClose, children }) => {
  return (
    <div
      className={`fixed inset-0 top-0  flex items-center px-4 md:px-0 justify-center bg-black/80 z-50  `}
    >
      
      {children}
    </div>
  );
};

export default Modal;
